"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenserControlManualCommandsValidation = void 0;
class DispenserControlManualCommandsValidation {
    static isValid(entity) {
        // If entity.reset_coolio exists, validate that it has the correct type.
        if (entity.reset_coolio != undefined) {
            if (typeof entity.reset_coolio !== "boolean")
                return false;
        }
        return true;
    }
}
exports.DispenserControlManualCommandsValidation = DispenserControlManualCommandsValidation;
